import { CartAddEvent } from '@theme/events';

/**
 * Global AJAX cart functionality for product cards
 */
class ProductCardAjax {
  constructor() {
    this.init();
  }

  init() {
    // Use event delegation to handle dynamically loaded content
    document.addEventListener('submit', this.handleFormSubmit.bind(this));
  }

  handleFormSubmit(event) {
    const form = event.target;
    
    // Only handle product card forms with data-ajax-cart attribute
    if (!form.classList.contains('product-card__form') || !form.hasAttribute('data-ajax-cart')) {
      return;
    }

    event.preventDefault();
    
    const button = form.querySelector('.product-card__add-to-cart');
    const buttonText = button.querySelector('.product-card__button-text');
    const originalText = buttonText.innerHTML;

    // Show loading state
    button.disabled = true;
    buttonText.textContent = 'ADDING...';
    
    const formData = new FormData(form);
    
    fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // Show success state
      buttonText.textContent = 'ADDED!';
      button.classList.add('product-card__add-to-cart--success');
      
      // Reset after 2 seconds
      setTimeout(() => {
        const isHeritage = button.dataset.heritageSource === 'true';
        if (!isHeritage) {
          button.disabled = false;
        }
        buttonText.innerHTML = originalText;
        button.classList.remove('product-card__add-to-cart--success');
      }, 2000);

      // Dispatch CartAddEvent for Horizon's cart system
      const cartAddEvent = new CartAddEvent(
        data, // resource
        form.id || 'product-card', // sourceId
        {
          source: 'product-card',
          itemCount: data.item_count,
          productId: form.closest('.product-card')?.dataset?.productId,
          variantId: formData.get('id')
        }
      );
      
      document.dispatchEvent(cartAddEvent);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      buttonText.textContent = 'ERROR';
      button.classList.add('product-card__add-to-cart--error');
      
      // Reset after 2 seconds
      setTimeout(() => {
        const isHeritage = button.dataset.heritageSource === 'true';
        if (!isHeritage) {
          button.disabled = false;
        }
        buttonText.innerHTML = originalText;
        button.classList.remove('product-card__add-to-cart--error');
      }, 2000);
    });
  }
}

// Initialize once and use singleton pattern
let productCardAjax = null;

function initializeProductCardAjax() {
  if (!productCardAjax) {
    productCardAjax = new ProductCardAjax();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeProductCardAjax);

// Also initialize immediately if DOM is already loaded (for AJAX content)
if (document.readyState !== 'loading') {
  initializeProductCardAjax();
}
